module.exports = "\r\n<nav class=\"leftsettingbox\">\r\n    <ul class=\"list-unstyled settinglist\">   \r\n           <li> <a [routerLink]=\"['hrmsEmployee']\" hasPermission=\"admin.hrms.hrmsEmployee.active\"  routerLinkActive=\"selected\" ><section>&nbsp;&nbsp; Hrms</section></a>\r\n           </li>\r\n         \r\n    </ul>     \r\n</nav>  \r\n<router-outlet></router-outlet>  "


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/hrms/hrms.component.html
// module id = ./src/app/admin/hrms/hrms.component.html
// module chunks = main